import EHRVisibility from './EHRVisibility';
import { useTranslation } from 'react-i18next';

const EHRVisivilityModal = ({ onHide, visibility, onChange, onSave, type, resourceVisibility, resource }) => {
  const { t } = useTranslation();
  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {
                t(
                  `ehr:visibility_config_title_${type}`,
                  { defaultValue: type === 'resource' ? 'Visibilidad de tus registros en HCE' : 'Visibilidad para este registro'}
                )
              }
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => onHide()}
            ></button>
          </div>
          <div className="modal-body">
            <EHRVisibility
              visibility={visibility}
              onChange={onChange}
              type={type}
              resourceVisibility={resourceVisibility}
              resource={resource}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => onHide()}
            >
              {t('cancel', 'Cancelar')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSave}
            >
              {t('save', 'Guardar')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EHRVisivilityModal;